import { render, staticRenderFns } from "./chooseDevice.vue?vue&type=template&id=05512d26&scoped=true"
import script from "./chooseDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseDevice.vue?vue&type=script&setup=true&lang=js"
import style0 from "./chooseDevice.vue?vue&type=style&index=0&id=05512d26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05512d26",
  null
  
)

export default component.exports